<script>

import userService from '@/services/user.service'
import accountService from '@/services/account.service'
import moment from 'moment'
import AccountModal from '@/components/account/AccountModal.vue'
import AccountGroupDelegateModal from '@/components/account/AccountGroupDelegateModal.vue'
import AccountGroupModal from '@/components/account/AccountGroupModal.vue'
import AccountEditModal from '@/components/account/AccountEditModal.vue'
import AccountDelegateModal from '@/components/account/AccountDelegateModal.vue'
import AccountDelegateListModal from '@/components/account/AccountDelegateListModal.vue'
import AccountGroupDelegateListModal from '@/components/account/AccountGroupDelegateListModal.vue'
import Icon from "@/components/Icon/Icon.vue"
import ConfirmDialog from 'primevue/confirmdialog'

export default {
  name: 'DashboardPage',
  components: {
    Icon,
    AccountModal,
    AccountGroupDelegateModal,
    AccountGroupModal,
    AccountEditModal,
    AccountDelegateModal,
    AccountDelegateListModal,
    AccountGroupDelegateListModal,
    ConfirmDialog,
  },
  data() {
    return {
        accountsGroup: [],
        accountsGroupDelegate: [],
        accounts: [],
        uuidSelected: '',
        groupeSelected: '',
        ownerSelected: false,
        uuidChoice: '',
        showModal: false,
        uuidAccount: '',
        nameAccount: '',
        showAccountModal: false,
        showAccountShareModal: false,
        showEditGroupModal: false,
        showDelegateModal: false,
        showDelegateListModal: false,
        showGroupDelegateListModal: false,
        loadingGroups: false,
        loadingAccounts: true,
    };
  },
  methods: {
    createAccountName(accountName) {
      localStorage.setItem('account_name', accountName)
    },
    showStatus(status, mode) {
      if(status == 1) {
        return 'Fermé'
      }

      let s = 'Activé'
      switch(mode) {
          case 0:
              s = 'Démo'
              break
      }
      return s
    },
    showExpirationDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    loadAccount(accountGroupUuid, owner) {
        this.loadingAccounts = false
        this.uuidChoice = accountGroupUuid
        this.ownerSelected = owner

        accountService.getAccounts(accountGroupUuid).then(data => {
            this.accounts = data.accounts

            this.loadingAccounts = true
        });
    },
    openModal(uuid = '', name = '') {
        this.uuidSelected = uuid
        this.groupeSelected = name
        this.showModal = true
    },
    delegateGroupConfirm(uuid, name) {
        this.uuidSelected = uuid
        this.groupeSelected = name
        this.showDelegateModal = true
    },
    editGroup(uuid, name) {
        this.uuidSelected = uuid
        this.groupeSelected = name
        this.showEditGroupModal = true
    },
    removeGroupConfirm(uuid, name) {
        this.$confirm.require({
            message: 'Voulez-vous fermer le groupe "' + name + '" ?',
            header: 'Fermer le groupe',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Annuler',
            acceptLabel: 'Fermer',
            rejectClass: 'p-2',
            acceptClass: 'p-2 text-red-600',
            accept: () => {
              accountService.deactivate(uuid).then((data) => {
                    userService.getAccountsGroupRoot().then(data => {
                      this.accountsGroup = []
                      this.accountsGroupDelegate = []
                      data.accounts_group.forEach((item) => {
                        if(item.accountuser.owner == true) {
                          this.accountsGroup.push(item)
                        } else {
                          this.accountsGroupDelegate.push(item)
                        }
                      })
                      this.accounts = []
                    })
                })
            },
            reject: () => {
                //this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    },
    reactivateGroupConfirm(uuid, name) {
        this.$confirm.require({
            message: 'Voulez-vous réactiver le groupe "' + name + '" ?',
            header: 'Réactiver',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Annuler',
            acceptLabel: 'Réactiver',
            rejectClass: 'p-2',
            acceptClass: 'p-2 text-red-600',
            accept: () => {
              accountService.activate(uuid).then((data) => {
                    userService.getAccountsGroupRoot().then(data => {
                      this.accountsGroup = []
                      this.accountsGroupDelegate = []
                      data.accounts_group.forEach((item) => {
                        if(item.accountuser.owner == true) {
                          this.accountsGroup.push(item)
                        } else {
                          this.accountsGroupDelegate.push(item)
                        }
                      })
                      this.accounts = []
                    })

                    this.$store.dispatch('account/reset')
                })
            },
            reject: () => {
                //this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    },
    removeAccountConfirm(uuid, name) {
        this.$confirm.require({
            message: 'Voulez-vous fermer l\'agenda "' + name + '" ?',
            header: "Fermer l'agenda",
            icon: 'pi pi-info-circle',
            rejectLabel: 'Annuler',
            acceptLabel: 'Fermer',
            rejectClass: 'p-2',
            acceptClass: 'p-2 text-red-600',
            accept: () => {
                accountService.deactivate(uuid).then((data) => {
                    let foundIndex = this.accounts.findIndex(element => element.uuid == uuid)
                    this.accounts[foundIndex] = data
                })

                this.$store.dispatch('account/reset')
            },
            reject: () => {
                //this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    },
    reactivateAccountConfirm(uuid, name) {
        this.$confirm.require({
            message: 'Voulez-vous réactiver l\'agenda "' + name + '" ?',
            header: 'Réactiver',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Annuler',
            acceptLabel: 'Réactiver',
            rejectClass: 'p-2',
            acceptClass: 'p-2 text-red-600',
            accept: () => {
                accountService.activate(uuid).then((data) => {
                  let foundIndex = this.accounts.findIndex(element => element.uuid == uuid)
                  this.accounts[foundIndex] = data
                })
            },
            reject: () => {
                //this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    },
    openAccountEditModal(uuid, name) {
        this.uuidAccount = uuid
        this.nameAccount = name
        this.showAccountModal = true
    },
    openAccountShareModal(uuid, name) {
        this.uuidAccount = uuid
        this.nameAccount = name
        this.showAccountShareModal = true
    },
    openAccountShareListModal(uuid, name) {
        this.uuidAccount = uuid
        this.nameAccount = name
        this.showDelegateListModal = true
    },
    openAccountGroupShareListModal(uuid, name) {
      this.uuidSelected = uuid
      this.groupeSelected = name
      this.showGroupDelegateListModal = true
    },
    closeCallback(action) {
      if(action.traited === true) {
        userService.getAccountsGroupRoot().then(data => {
            this.accountsGroup = []
            this.accountsGroupDelegate = []
            data.accounts_group.forEach((item) => {
              if(item.accountuser.owner == true) {
                this.accountsGroup.push(item)
              } else {
                this.accountsGroupDelegate.push(item)
              }
            })
            
            this.uuidChoice = action.uuidGroupe

            accountService.getAccounts(action.uuidGroupe).then(data => {
                this.accounts = data.accounts
            });

        })
      }
      this.uuidSelected = ''
      this.groupeSelected = ''
      this.showModal = false
    },
    closeGroupDelegateCallback(action) {
      this.uuidSelected = ''
      this.groupeSelected = ''
      this.showDelegateModal = false
    },
    closeGroupCallback(action) {
      if(action.traited === true) {
        let found = this.accountsGroup.find((element => element.account.uuid == this.uuidSelected))
        found.account.name = action.name
        found.account.sid = action.sid
      }

      this.uuidSelected = ''
      this.groupeSelected = ''
      this.showEditGroupModal = false
    },
    closeAccountCallback(action) {
      if(action.traited === true) {
        let found = this.accounts.find((element => element.uuid == this.uuidAccount))
        found.name = action.name
        found.sid = action.sid
      }

      //this.uuidAccount = ''
      this.nameAccount = ''
      this.showAccountModal = false
    },
    closeAccountDelegateCallback(action) {
      this.uuidAccount = ''
      this.nameAccount = ''
      this.showAccountShareModal = false
    },
    closeAccountDelegateListCallback(action) {
      this.uuidAccount = ''
      this.nameAccount = ''

      this.showDelegateListModal = false
    },
    closeAccountGroupDelegateListCallback(action) {
      this.uuidSelected = ''
      this.groupeSelected = ''

      this.showGroupDelegateListModal = false
    },
    styleObject(uuid) {
        if(this.uuidChoice == uuid)
        {
            return {
                'box-shadow': 'rgba(0, 0, 0, 1.0) 0px 0px 10px, rgba(0, 0, 0, 1.0) 0 0 12px',
            }
        }

        return {}
      },
  },
  computed: {
      showCreatedAtFormat() {
        return d => moment(d).format('DD/MM/YYYY')
      },
    },
  created: function() {
    userService.getAccountsGroupRoot().then(data => {
      this.accountsGroup = []
      this.accountsGroupDelegate = []
      data.accounts_group.forEach((item) => {
        if(item.accountuser.owner == true) {
          this.accountsGroup.push(item)
        } else {
          this.accountsGroupDelegate.push(item)
        }
      })

      this.loadingGroups = true

      if(this.accountsGroup.length == 1) {
          accountService.getAccounts(this.accountsGroup[0].uuid).then(data => {
            this.accounts = data.accounts

            this.loadingAccounts = true
        });
      }
    })
  },
};
</script>

<template>
  <div class="flex shrink-0 justify-between gap-6 m-8">
    <AccountModal
        :externUuidModal="uuidSelected"
        :externGroupeModal="groupeSelected"
        :externShowModal="showModal"
        @close="closeCallback"
    />

    <AccountGroupDelegateModal
        :externUuidModal="uuidSelected"
        :externGroupeModal="groupeSelected"
        :externShowEditGroupModal="showDelegateModal"
        @close="closeGroupDelegateCallback"
    />

    <AccountGroupModal
        :externUuidModal="uuidSelected"
        :externGroupeModal="groupeSelected"
        :externShowEditGroupModal="showEditGroupModal"
        @close="closeGroupCallback"
    />

    <AccountEditModal
        :externUuidModal="uuidAccount"
        :externNameModal="nameAccount"
        :externShowEditModal="showAccountModal"
        @close="closeAccountCallback"
    />

    <AccountDelegateModal
        :externUuidModal="uuidAccount"
        :externNameModal="nameAccount"
        :externShowShareModal="showAccountShareModal"
        @close="closeAccountDelegateCallback"
    />

    <AccountDelegateListModal
        :externUuidModal="uuidAccount"
        :externNameModal="nameAccount"
        :externShowDelegateListModal="showDelegateListModal"
        @close="closeAccountDelegateListCallback"
    />

    <AccountGroupDelegateListModal
        :externUuidModal="uuidSelected"
        :externNameModal="groupeSelected"
        :externShowGroupDelegateListModal="showGroupDelegateListModal"
        @close="closeAccountGroupDelegateListCallback"
    />

    <ConfirmDialog />

    <div v-if="loadingGroups" class="w-1/2 flex flex-col gap-6">
      <div class="underline">Vos agendas</div>
      <div
        v-for="accountGroup in accountsGroup"
        :key="accountGroup.account.uuid"
        :style="styleObject(accountGroup.account.uuid)"
        class="rounded"
      >
        <div v-if="accountGroup.account.status == 0" class="flex px-8 py-4 justify-between border-solid border border-orange-300 w-full rounded gap-6 hover:shadow-md hover:shadow-[#676767]">
          <div>
            <div class="font-bold">Nom : {{ accountGroup.account.name }}</div>
            <div>Créé le : {{ showCreatedAtFormat(accountGroup.account.created_at) }}</div>
          </div>
          <div class="w-1/3 text-right">
            <button class="hover:underline" @click="loadAccount(accountGroup.account.uuid, accountGroup.accountuser.owner)">Voir les agendas</button>
            <br />
            <button @click="openModal(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Créer un agenda
            </button>
            <button @click="delegateGroupConfirm(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Déléguer le groupe
            </button>
            <button @click="openAccountGroupShareListModal(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Voir les délégués
            </button>
            <button @click="editGroup(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Modifier le groupe
            </button>
            <button @click="removeGroupConfirm(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Fermer le groupe
            </button>
          </div>
        </div>
        <div v-else-if="accountGroup.account.status == 1" class="flex px-8 py-2 bg-gray-100 justify-between border-solid border border-gray-400 w-full rounded gap-6">
          <div>
            <div class="font-bold">Nom : {{ accountGroup.account.name }}</div>
            <div>Fermé le : {{ showCreatedAtFormat(accountGroup.account.modified_at) }}</div>
          </div>
          <div class="w-1/3 text-right">
            <button @click="reactivateGroupConfirm(accountGroup.account.uuid, accountGroup.account.name)" class="hover:underline">
              Réactiver le groupe
            </button>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button @click="openModal()" class="hover:underline">Créer un agenda dans un nouveau groupe</button>
      </div>

      <div v-show="accountsGroupDelegate.length" class="underline">Les comptes délégués</div>
      <div
        v-for="accountGroup in accountsGroupDelegate"
        :key="accountGroup.account.uuid"
        :style="styleObject(accountGroup.account.uuid)"
      >
        <div v-if="accountGroup.account.status == 0" class="flex px-8 py-4 justify-between border-solid border border-orange-800 w-full rounded gap-6 hover:shadow-md hover:shadow-[#676767]">
          <div>
            <div class="font-bold">Nom : {{ accountGroup.account.name }}</div>
            <div>Créé le : {{ showCreatedAtFormat(accountGroup.account.created_at) }}</div>
          </div>
          <div class="w-1/3 text-right">
            <button class="hover:underline" @click="loadAccount(accountGroup.account.uuid, accountGroup.accountuser.owner)">Voir les agendas</button>
          </div>
        </div>
        <div v-else-if="accountGroup.account.status == 1" class="flex px-8 py-2 bg-gray-100 justify-between border-solid border border-gray-400 w-full rounded gap-6">
          <div>
            <div class="font-bold">Nom : {{ accountGroup.account.name }}</div>
            <div>Fermé le : {{ showCreatedAtFormat(accountGroup.account.modified_at) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
          v-else
          class="w-1/2 flex flex-col items-center justify-center text-xl"
      >
        <img alt="Loading" src="/loading.gif" width="125" height="125" />
        Chargement...
    </div>

    <div class="w-1/2 flex justify-center">
      <div class="mx-auto">
        <table>
          <thead class="border-b font-medium dark:border-neutral-500">
              <tr>
                <th scope="col" class="px-6 py-4" @click="sort()">Agenda</th>
                <th scope="col" class="px-6 py-4">Expiration</th>
                <th scope="col" class="px-6 py-4">Actions</th>
              </tr>
          </thead>
          <tbody>
              <tr
                  class="border-b dark:border-neutral-500"
                  v-for="account in accounts"
                  :key="account.uuid"
                  v-if="loadingAccounts"
              >
              <td v-if="account.status == 0" class="whitespace-nowrap px-6 py-2">
                <router-link
                  @click="createAccountName(account.sid)"
                  :to="{name: 'agenda', params: {account: account.sid}}"
                  class="hover:underline"
                >
                  {{ account.name }}
                </router-link>
              </td>
              <td v-if="account.status == 0" class="whitespace-nowrap px-6 py-2">
                  {{ showExpirationDate(account.closed_at) }}
              </td>
              <td v-if="account.status == 0" class="whitespace-nowrap px-6 py-2">
                  <div v-show="ownerSelected" class="flex">
                    <div :idAccount="account.uuid" @click="openAccountEditModal(account.uuid, account.name)" class="hover:cursor-pointer">
                        <icon name="pencil" :size="16" color="black" class="w-6 h-6" />
                    </div>
                    <div :idAccount="account.uuid" @click="openAccountShareModal(account.uuid, account.name)" class="hover:cursor-pointer">
                        <icon name="share" :size="16" color="black" class="w-6 h-6" />
                    </div>
                    <div :idAccount="account.uuid" @click="openAccountShareListModal(account.uuid, account.name)" class="hover:cursor-pointer">
                        <icon name="user" :size="16" color="black" class="w-6 h-6" />
                    </div>
                    <div :idAccount="account.uuid" @click="removeAccountConfirm(account.uuid, account.name)" class="hover:cursor-pointer">
                        <icon name="trash-o" :size="16" color="black" class="w-6 h-6" />
                    </div>
                  </div>
              </td>
              <td v-if="account.status == 1" class="whitespace-nowrap px-6 py-2">
                <span class="text-gray-400">{{ account.name }}</span>
              </td>
              <td v-if="account.status == 1" class="whitespace-nowrap px-6 py-2">
                <span class="text-gray-400">{{ showExpirationDate(account.closed_at) }}</span>
              </td>
              <td v-if="account.status == 1 && ownerSelected"class="whitespace-nowrap px-6 py-2">
                  <div :idAccount="account.uuid" @click="reactivateAccountConfirm(account.uuid, account.name)" class="hover:cursor-pointer">
                      Réactiver
                  </div>
              </td>
              </tr>
              <tr
                  v-else
                  class="text-xl"
              >
                <td colspan="2">
                  <div class="m-6 text-center">
                    <img class="mx-auto" alt="Loading" src="/loading.gif" width="125" height="125" />
                    <span>Chargement...</span>
                  </div>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
